/**
 * USE : import dayjs from "@/lib/dayjs";
**/

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("America/Chicago");

export default dayjs;
export type { Dayjs } from "dayjs";
